/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from 'react';
import Accesspage from './../../common/404';
import Estimate_List from './../../modules/Master/estimate_list';
import Rooms from './../../modules/Master/rooms';
import Investigations from './../../modules/Master/investigations';
import Includes from './../../modules/Master/includes';
import Exclude from './../../modules/Master/excludes';
import Drugs from './drugs';
import ConsentProcedures from './consentProcedures';
import Nme from './nme';
import TpasAndInsurnaceComanpies from './tpas_insurance';
import Packages from './packages';
import Services from './services';
import RoomImages from './roomImages';
import Traiffs from './tariffs';

class Master extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            "showAdd": false,
            "showEdit": false,
            "showView": false,
        };
    }
    componentDidMount() {
        // this.renderPermission();
    }
    renderbodyLayer() {
        const { id, slug } = this.props.match.params
        const { menuList } = this.props;
        let showAdd = false;
        let showEdit = false;
        let showView = false;
        // let obj = null;
        // menuList.map(data => {
        //     var subData = data
        //         .submenu
        //         .find(o => o.route === slug);
        //     console.log(subData);
        //     if (subData != undefined) {
        //         obj = subData;
        //     }
        // })


        // menuList.map((menu) => {
        //     if (slug !== undefined && slug !== null && slug !== '') {

        //         if (menu['route'] === id) {
        //             menu['submenu'].map((smenu) => {
        //                 if (slug === 'add-user' || slug === 'edit-user' || slug === 'view-user') {
        //                     menu['submenu'].map((srmenu) => {
        //                         if (srmenu['route'] === 'users') {
        //                             showView = JSON.parse(srmenu['permissions']['view']);
        //                             showAdd = JSON.parse(srmenu['permissions']['add']);
        //                             showEdit = JSON.parse(srmenu['permissions']['edit']);
        //                         }
        //                     });
        //                 }
        //                 if (slug === 'add-counselling-stations' || slug === 'edit-counselling-stations' || slug === 'view-counselling-stations') {
        //                     menu['submenu'].map((srmenu) => {
        //                         if (srmenu['route'] === 'counselling-stations') {
        //                             showView = JSON.parse(srmenu['permissions']['view']);
        //                             showAdd = JSON.parse(srmenu['permissions']['add']);
        //                             showEdit = JSON.parse(srmenu['permissions']['edit']);
        //                         }
        //                     });
        //                 }
        //                 if (slug === 'add-doctor' || slug === 'edit-doctor' || slug === 'view-doctor') {
        //                     menu['submenu'].map((srmenu) => {
        //                         if (srmenu['route'] === 'doctors') {
        //                             showView = JSON.parse(srmenu['permissions']['view']);
        //                             showAdd = JSON.parse(srmenu['permissions']['add']);
        //                             showEdit = JSON.parse(srmenu['permissions']['edit']);
        //                         }
        //                     });
        //                 }

        //                 if (slug === 'add-role' || slug === 'edit-role' || slug === 'view-role') {
        //                     menu['submenu'].map((srmenu) => {
        //                         if (srmenu['route'] === 'roles') {
        //                             showView = JSON.parse(srmenu['permissions']['view']);
        //                             showAdd = JSON.parse(srmenu['permissions']['add']);
        //                             showEdit = JSON.parse(srmenu['permissions']['edit']);
        //                         }
        //                     });
        //                 }

        //                 if (slug === 'edit-privilege') {
        //                     menu['submenu'].map((smenu) => {
        //                         showEdit = JSON.parse(smenu['permissions']['edit']);
        //                     });
        //                 }

        //                 if (smenu['route'] === slug) {
        //                     showView = JSON.parse(smenu['permissions']['view']);
        //                     showAdd = JSON.parse(smenu['permissions']['add']);
        //                     showEdit = JSON.parse(smenu['permissions']['edit']);
        //                 }
        //             })
        //         }
        //     }

        //     if (slug === undefined && id !== undefined) {
        //         if (menu['route'] === id) {
        //             showView = JSON.parse(menu['permissions']['view']);
        //             showAdd = JSON.parse(menu['permissions']['add']);
        //             showEdit = JSON.parse(menu['permissions']['edit']);
        //         }
        //     }
        // })



        var page = null;
        // if (obj !== undefined) {
        switch (slug) {
            case 'estimate_list':
                page = <Estimate_List {...this.props} menuList={menuList} />;
                // page = <Rooms {...this.props} menuList={menuList} />;
                // page = <Investigations {...this.props} menuList={menuList} />;
                // page = <Includes {...this.props} menuList={menuList} />;
                // page = <Exclude {...this.props} menuList={menuList} />;
                // page = <Drugs {...this.props} menuList={menuList} />;
                // page = <ConsentProcedures {...this.props} menuList={menuList} />;
                // page = <Nme {...this.props} menuList={menuList} />;
                // page = <TpasAndInsurnaceComanpies {...this.props} menuList={menuList} />;
                // page = <Packages {...this.props} menuList={menuList} />;
                // page = <Services {...this.props} menuList={menuList} />;
                // page = <RoomImages {...this.props} menuList={menuList} />;
                // page = <Traiffs {...this.props} menuList={menuList} />;
                break;
            default:
                let submenu = null;
                page = <Accesspage></Accesspage>;
                break;
        }
        return page;
    }


    render() {

        return (
            <div>
                {this.renderbodyLayer()}
            </div>
        );
    }
}

export default Master;
